var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { staticStyle: { height: "auto", "margin-top": "10px" } },
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "unlink-panels": "",
                          type: _vm.dateType,
                          "range-separator": _vm.$i18n.t("common.to"),
                          "start-placeholder": _vm.$i18n.t("common.Startdate"),
                          "end-placeholder": _vm.$i18n.t("common.Enddate"),
                          "picker-options": _vm.pickerOptions,
                          clearable: false,
                          "default-time": ["00:00:00", "23:59:59"]
                        },
                        model: {
                          value: _vm.valuePicker,
                          callback: function($$v) {
                            _vm.valuePicker = $$v
                          },
                          expression: "valuePicker"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "", change: "" },
                          model: {
                            value: _vm.orderstaticRequest.timeType,
                            callback: function($$v) {
                              _vm.$set(_vm.orderstaticRequest, "timeType", $$v)
                            },
                            expression: "orderstaticRequest.timeType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$i18n.t("common.Hourlystatistics"),
                              value: "false"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$i18n.t("common.Countbyday"),
                              value: "true"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c("dataSelect", {
                        attrs: {
                          clearable: "",
                          codeType: "countrys",
                          placeholder: _vm.$i18n.t("common.SalesCountry")
                        },
                        model: {
                          value: _vm.orderstaticRequest.countryCode,
                          callback: function($$v) {
                            _vm.$set(_vm.orderstaticRequest, "countryCode", $$v)
                          },
                          expression: "orderstaticRequest.countryCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            icon: "el-icon-search"
                          },
                          on: { click: _vm.initEcharts }
                        },
                        [_vm._v(_vm._s(_vm.$i18n.t("common.query")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-main",
            [
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ]
                },
                [
                  _c("div", {
                    staticClass: "echart",
                    style: { float: "left", width: "100%", height: "600px" },
                    attrs: { id: "myChart2" }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              staticStyle: {
                width: "50%",
                "text-align": "center",
                margin: "auto"
              },
              attrs: { data: _vm.orderData, border: "", "show-summary": "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$i18n.t("common.Ordertime"),
                  prop: "orderTime",
                  align: "center",
                  "show-overflow-tooltip": "",
                  formatter: _vm.formatDate
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderAmount",
                  sortable: "",
                  label: _vm.$i18n.t("common.OrderQuantity")
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "saleAmount",
                  sortable: "",
                  label: _vm.orderAmountLabel
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "balancedDiscountAmt",
                  sortable: "",
                  label: _vm.$i18n.t("common.AIGOCoins")
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "fullGiftAmount",
                  sortable: "",
                  label: _vm.$i18n.t("common.NumberOfGiftsIssued")
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "customUnitPrice",
                  sortable: "",
                  label: _vm.$i18n.t("common.CustomerPrice")
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }